<template>
    <div class="manage-detail" v-if="eventObj.id">
        <div class="nav-link">
            <a
                class="goToProp"
                @click="goToPage"
                v-if="showManage"
            >{{$t('manage.BackManage')}} {{eventObj.property_name}}</a>
            <a class="goToProp" @click="changeView" v-if="showEvent">{{$t('manage.BackEvent')}}</a>
        </div>

        <el-row :gutter="20">
            <el-col :xs="24" :md="15">
                <div class="event-detail">
                    <manageUpload
                        :selectProp="selectProp"
                        :uploadList="uploadList"
                        :requestParams="requestParams"
                        :requestHeaders="requestHeaders"
                        @changeView="changeView"
                        v-if="displayView == 'upload'"
                    />

                    <div v-else>
                        <div class="event-profile">
                            <div class="profile-l">
                                <h4>{{eventObj.property_name}}</h4>
                                <div class="name">{{eventObj.name}}</div>
                                <div class="date">{{$t('manage.DueDate')}} : {{eventObj.due_date}}</div>
                            </div>
                            <div class="profile-r">
                                <div class="status" :class="eventObj.status">
                                    <span
                                        v-if="eventObj.status != 'TODO'"
                                    >{{translateStatus(eventObj.status)}}</span>
                                    <span v-else>{{$t('manage.ActionRequired')}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="event-item">
                            <h3>{{$t('manage.TaskDetails')}}</h3>
                            <iframe
                                width="100%"
                                height="500"
                                frameborder="0"
                                scrolling="auto"
                                :src="eventObj.details"
                            ></iframe>
                            <div
                                v-if="eventObj.status == 'TODO' || eventObj.status == 'OVERDUE' || eventObj.status == 'ERROR'"
                            >
                                <el-button
                                    type="primary"
                                    class="complete"
                                    v-if="eventObj.action_required == 'TO_COMPLETE'"
                                    @click="openDialog"
                                >{{$t('manage.MarkComplete')}}</el-button>
                                <el-button
                                    type="primary"
                                    class="upload"
                                    v-if="eventObj.action_required == 'TO_UPLOAD'"
                                    @click="openUpload"
                                >{{$t('manage.UploadNow')}}</el-button>
                                <div v-if="eventObj.action_required == 'TO_SIGN'">
                                    <a
                                        class="sign solid-btn"
                                        :href="eventObj.signature_url"
                                        target="_blank"
                                    >
                                        <span>{{$t('manage.SignNow')}}</span>
                                    </a>
                                    <p class="updateHint">{{$t('planner.updateHint')}}</p>
                                </div>
                                <el-button
                                    type="primary"
                                    class="pay"
                                    v-if="eventObj.action_required == 'TO_PAY'"
                                >{{$t('manage.PayNow')}}</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>

            <el-col :xs="24" :md="9">
                <ul v-if="eventObj.action_required == 'TO_UPLOAD' " class="file-uploaded-list">
                    <li v-for="(item, index) in file_list" :key="index">
                        <a :href="item.file" target="_blank" class="column-link" v-if="item.file">
                            <span v-if="item.file_type == 'FILE'" class="file-img">
                                <img :src="iconFile" />
                            </span>
                            <span class="file-img" v-else>
                                <img :src="iconJPG" :alt="item.title" />
                            </span>
                            <span class="file-title">{{item.title}}</span>
                            <span class="file-name">{{item.filename}}</span>
                        </a>
                    </li>
                </ul>
            </el-col>
        </el-row>

        <el-dialog :visible.sync="centerDialogVisible" width="30%" center>
            <span class="icon-complete">
                <img src="../../../../website_20/static/img/manage/icon-oval-60.svg" alt />
            </span>
            <span>{{$t('manage.ConfirmTitle')}}</span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="markAsComplete">{{$t('manage.Confirm_y')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import manageUpload from "@/components/account/manageUpload.vue";
import { Loading } from "element-ui";
import { Dialog } from "element-ui";

let loading;
let _Dialog;

export default {
    name: "manageDetail",
    props: ["selectProp", "requestParams", "requestHeaders", "eventId"],
    data() {
        let iconFile = require("../../../../website_20/static/img/manage/icon-pdf.svg");
        let iconJPG = require("../../../../website_20/static/img/manage/icon-jpg.svg");
        const $t = this.$t.bind(this);
        return {
            details_html: "",
            centerDialogVisible: false,
            showManage: true,
            showEvent: false,
            displayView: "",
            uploadList: [],
            eventObj: {},
            iconFile: iconFile,
            iconJPG: iconJPG,
            file_list: []
        };
    },

    mounted() {
        this.getDetail();
    },

    beforeMount() {
        _Dialog = Dialog;
    },

    methods: {
        getDetail() {
            this.loading();

            let eventDetailUrl = `${this.requestParams.ppbApi}api/passbook/event/${this.eventId}`;
            this.$http.get(eventDetailUrl, this.requestHeaders).then(resp => {
                this.eventObj = resp.data;
            });

            let documentUrl = `${this.requestParams.ppbApi}api/passbook/document/${this.eventId}`;
            this.$http.get(documentUrl, this.requestHeaders).then(resp => {
                this.file_list = resp.data;
            });
            loading.close();
        },

        openDialog() {
            this.centerDialogVisible = true;
        },

        openUpload() {
            this.displayView = "upload";
            this.showManage = false;
            this.showEvent = true;
            this.loading();

            let eventDetailUrl = `${this.requestParams.ppbApi}api/passbook/document/${this.eventObj.id}`;
            this.$http.get(eventDetailUrl, this.requestHeaders).then(resp => {
                this.uploadList = resp.data;
            });
            loading.close();
        },

        markAsComplete() {
            let changeStatusUrl = `${this.requestParams.ppbApi}api/passbook/event/${this.eventObj.id}`;
            let params = {
                id: this.eventObj.id,
                status: "PENDING"
            };
            this.centerDialogVisible = false;
            this.loading();

            this.$http
                .put(changeStatusUrl, params, this.requestHeaders)
                .then(resp => {
                    if (resp.data.status == "ok") {
                        loading.close();
                        this.eventObj.status = "PENDING";
                    }
                });
        },

        goToPage() {
            this.$emit("goToPage", "main");
        },

        translateStatus(val) {
            if (val == "PENDING") {
                return this.$t("manage.Pending");
            } else if (val == "FUTURE") {
                return this.$t("manage.Future");
            } else if (val == "TODO") {
                return;
            } else if (val == "OVERDUE") {
                return this.$t("manage.OverDue");
            } else if (val == "ERROR") {
                return this.$t("manage.Error");
            } else if (val == "COMPLETED") {
                return this.$t("manage.Completed");
            } else if (val == "UPDATE") {
                return this.$t("manage.Update");
            } else if (val == "FUTURE_UPDATE") {
                return this.$t("manage.Update");
            }
        },

        changeView(data) {
            this.displayView = "";
            this.showManage = true;
            this.showEvent = false;
            this.getDetail();
        },

        loading() {
            loading = this.$loading({
                lock: true,
                target: ".manageContainer",
                text: this.$t("searchResultPage.loading"),
                color: "#3b6bbf",
                background: "rgba(255, 255, 255, 0.8)"
            });
        }
    },

    filters: {
        formatStatus(val) {
            return val.toLowerCase().replace(/_/g, " ");
        }
    },

    components: {
        manageUpload
    }
};
</script>
<style lang="scss">
.manage-detail {
    .goToProp {
        font-family: GothamBook;
        font-size: 14px;
        color: var(--windows-blue);
        &::before {
            content: "";
            display: inline-block;
            width: 15px;
            height: 12px;
            margin-right: 9px;
            background: url("../../../../website_20/static/img/icon-arrow-l-blue.svg")
                no-repeat;
            background-size: contain;
        }
    }

    .nav-link {
        margin-bottom: 30px;
    }

    .event-detail {
        box-shadow: 0 5px 10px -10px rgba(0, 0, 0, 0.2);
        border: solid 1px #eaf0f7;
        border-top: 8px solid #3b6bbf;
        background-color: #fff;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        @media (max-width: 414px) {
            border-top: 1px solid #eaf0f7;
            border-radius: 0;
            border-left: 0;
            border-right: 0;
        }
        .event-profile {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 25px 20px;
            border-bottom: solid 1px #eaf0f7;
            @media (max-width: 414px) {
                padding: 25px 0;
            }
            .profile-l {
                h4 {
                    font-family: GothamBook;
                    font-size: 13px;
                    color: #333333;
                    margin-bottom: 10px;
                }
                .name {
                    font-family: GothamMedium;
                    font-size: 14px;
                    font-weight: 500;
                    color: #333333;
                    margin-bottom: 10px;
                }
                .date {
                    font-family: GothamBook;
                    font-size: 12px;
                    letter-spacing: 0.4px;
                    color: var(--windows-blue);
                    &::before {
                        content: "";
                        display: inline-block;
                        width: 10px;
                        height: 10px;
                        border-radius: 50%;
                        margin-right: 10px;
                        border: solid 3px var(--windows-blue);
                        background-color: var(--white);
                    }
                }
                @media (max-width: 768px) {
                    display: block;
                    width: 100%;
                }
            }
            .profile-r {
                .status {
                    font-family: GothamBook;
                    font-size: 14px;
                    letter-spacing: 0.46px;
                    color: var(--windows-blue);
                    text-transform: capitalize;

                    &::after {
                        content: "";
                        display: inline-block;
                        margin-bottom: -9px;
                        margin-left: 5px;
                        width: 30px;
                        height: 30px;
                    }
                    @media (max-width: 414px) {
                        position: relative;
                        margin-right: 20px;
                        &::after {
                            width: 20px;
                            height: 20px;
                            position: absolute;
                        }
                    }
                    &.FUTURE {
                        color: var(--brownish-grey);
                        &::after {
                            background: url("../../../../website_20/static/img/manage/icon-furture.svg")
                                no-repeat;
                            background-size: contain;
                        }
                    }
                    &.TODO::after {
                        background: url("../../../../website_20/static/img/manage/icon-todo.svg")
                            no-repeat;
                        background-size: contain;
                    }
                    &.OVERDUE {
                        color: #bc3036;
                        &::after {
                            background: url("../../../../website_20/static/img/manage/icon-overdue.svg")
                                no-repeat;
                            background-size: contain;
                        }
                    }
                    &.ERROR {
                        color: #bc3036;
                        &::after {
                            background: url("../../../../website_20/static/img/manage/icon-error.svg")
                                no-repeat;
                            background-size: contain;
                        }
                    }
                    &.PENDING::after {
                        background: url("../../../../website_20/static/img/manage/icon-pending.svg")
                            no-repeat;
                        background-size: contain;
                    }
                    &.COMPLETED {
                        color: #5cb642;
                        &::after {
                            background: url("../../../../website_20/static/img/manage/icon-completed.svg")
                                no-repeat;
                            background-size: contain;
                        }
                    }
                    &.UPDATE::after {
                        background: url("../../../../website_20/static/img/manage/icon-update.svg")
                            no-repeat;
                        background-size: contain;
                    }
                    &.FUTURE_UPDATE::after {
                        background: url("../../../../website_20/static/img/manage/icon-update.svg")
                            no-repeat;
                        background-size: contain;
                    }
                }
            }
        }
        .event-item {
            padding: 25px 20px;
            @media (max-width: 414px) {
                padding: 25px 0;
            }
            position: relative;
            h3 {
                margin-bottom: 15px;
                font-family: GothamMedium;
                font-size: 12px;
                letter-spacing: 1.12px;
                color: #333333;
            }
            iframe {
                padding-bottom: 20px;
                border-bottom: 1px solid #e7effc;
            }
            .el-button,
            .solid-btn {
                width: 100%;
                margin-top: 20px;
                padding-top: 0;
                padding-bottom: 0;
                border-color: transparent;
                height: 40px;
                border-radius: 4px;
                background-color: var(--windows-blue);
                color: #fff;
                line-height: 40px;
                box-shadow: none;
                span {
                    position: relative;
                    &::before {
                        content: "";
                        position: absolute;
                        display: inline-block;
                        width: 16px;
                        height: 16px;
                        left: -25px;
                        top: 0;
                    }
                }
                &.complete span::before {
                    background: url("../../../../website_20/static/img/icon-checkmark-white.svg")
                        no-repeat;
                    background-size: contain;
                }
                &.upload span::before {
                    background: url("../../../../website_20/static/img/manage/icon-attachment-white.svg")
                        no-repeat;
                    background-size: contain;
                }
                &.sign span::before {
                    background: url("../../../../website_20/static/img/manage/icon-sign-white.svg")
                        no-repeat;
                    background-size: contain;
                }
                &.pay span::before {
                    background: url("../../../../website_20/static/img/manage/icon-sign-white.svg")
                        no-repeat;
                    background-size: contain;
                }
            }
            .updateHint {
                margin-top: 5px;
                height: 42px;
                font-family: GothamBook;
                font-size: 14px;
                line-height: 1.5;
                color: var(--brownish-grey);
            }
        }
    }

    .file-uploaded-list {
        padding-left: 30px;
        @media (max-width: 768px) {
            padding-left: 0;
            margin-top: 30px;
        }
        li {
            .column-link {
                border-radius: 3px;
                box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.04);
                border: solid 1px #e5edf3;
                background-color: var(--white);
                margin-bottom: 10px;
                cursor: pointer;
                padding: 16px 18px;
                display: inline-block;
                width: 100%;
                height: 100%;
            }
            .file-img {
                display: inline-block;
            }
            .file-title {
                font-family: GothamMedium;
                font-size: 12px;
                font-weight: 500;
                color: #333333;
                margin-left: 10px;
                line-height: 1.23;
                display: inline-block;
                width: calc(100% - 45px);
                vertical-align: middle;
                margin-bottom: 5px;
            }
            .file-name {
                font-family: GothamBook;
                font-size: 11px;
                line-height: 1.23;
                color: var(--brownish-grey);
                display: inline-block;
                margin-left: 40px;
                vertical-align: middle;
            }
        }
    }

    .el-dialog__wrapper {
        .el-dialog__footer {
            .el-button--primary {
                border-color: transparent;
                width: 100%;
                height: 50px;
                border-radius: 4px;
                background-color: var(--windows-blue);
                margin: 0;
                margin-top: 10px;
            }
        }
        span {
            width: 100%;
            display: inline-block;
            text-align: center;
            img {
                margin: 0 auto;
                margin-bottom: 35px;
                width: 50px;
                height: 50px;
                object-fit: contain;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/account/manageDetails.vue